import { ConfigContainerChild, ConfigFilter, SelectedFilters } from "../types";

export const getFilterSelectedItems = (
  filterItems: ConfigContainerChild[],
  filters: SelectedFilters,
  cardFilters: ConfigFilter[],
) =>
  filterItems.filter(
    ({ options: { filterName } }) =>
      (Array.isArray(filters?.[filterName]?.value)
        ? !!(filters[filterName].value as string[]).length
        : !!filters[filterName]?.value) ||
      (filters?.[filterName]?.value === undefined &&
        !!cardFilters?.find(item => item.name === filterName)?.defaultValue),
  );
